export default __webpack_public_path__ + "static/media/WE THAI SMILE LOGO.f8837de1.webp";